import React from "react";
import { BANGLE_SIZES, RING_SIZES } from "@/lib/sizeGuide";

const th = "sticky top-0 bg-cream px-3 py-2.5 text-left text-[10px] font-medium uppercase tracking-[0.16em] text-muted-foreground";
const td = "px-3 py-2.5 text-sm text-ink";

export function RingSizeTable() {
  return (
    <div className="mt-6 max-h-[38vh] overflow-y-auto border border-border">
      <table className="w-full border-collapse" data-testid="size-guide-ring-table">
        <thead>
          <tr>
            <th className={th}>Indian</th>
            <th className={th}>Diameter</th>
            <th className={th}>Circumference</th>
            <th className={th}>US</th>
            <th className={th}>UK</th>
          </tr>
        </thead>
        <tbody>
          {RING_SIZES.map((s) => (
            <tr key={s.in} className="border-t border-border/70 odd:bg-white/50">
              <td className={`${td} font-serif text-base`}>{s.in}</td>
              <td className={td}>{s.dia.toFixed(1)} mm</td>
              <td className={td}>{s.circ.toFixed(1)} mm</td>
              <td className={td}>{s.us}</td>
              <td className={td}>{s.uk}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function BangleSizeTable() {
  return (
    <>
      <div className="mt-6 border border-border">
        <table className="w-full border-collapse" data-testid="size-guide-bangle-table">
          <thead>
            <tr>
              <th className={th}>Size</th>
              <th className={th}>Inner Ø (in)</th>
              <th className={th}>Inner Ø (mm)</th>
              <th className={th}>Circumference</th>
              <th className={`${th} hidden sm:table-cell`}>Fit</th>
            </tr>
          </thead>
          <tbody>
            {BANGLE_SIZES.map((b) => (
              <tr key={b.size} className="border-t border-border/70 odd:bg-white/50">
                <td className={`${td} font-serif text-base`}>{b.size}</td>
                <td className={td}>{b.diaIn}</td>
                <td className={td}>{b.diaMm.toFixed(1)} mm</td>
                <td className={td}>{b.circMm.toFixed(1)} mm</td>
                <td className={`${td} hidden text-muted-foreground sm:table-cell`}>{b.fit}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="mt-4 text-xs leading-relaxed text-muted-foreground">
        Bangle sizes follow the traditional Indian notation: “2.4” means an inner diameter of 2 and 4⁄16 inches.
      </p>
    </>
  );
}
